import { useEffect, useRef } from 'react';
import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async";
import { getPdfDownloadUrl } from '../utils/pdfApi';
import { HARPWOOD_WEBLINKS } from '../config/sharepointFundingPaths';

const CQC_WIDGET_SCRIPT_URL =
  'https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-2222753791&data-host=https://www.cqc.org.uk&type=location';

function CQCRegistration() {
  const widgetWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const wrapper = widgetWrapperRef.current;
    if (!wrapper) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = CQC_WIDGET_SCRIPT_URL;
    script.async = true;
    wrapper.appendChild(script);

    return () => {
      if (wrapper.contains(script)) {
        wrapper.removeChild(script);
      }
    };
  }, []);

  return (
    <>
    <Helmet>
    <title> CQC Rated Very Good | Registered Nursing Home Whitstable </title>
    <meta
      name="description"
      content=" Harpwood House is registered with the CQC and rated 'Very Good'. We provide regulated nursing and personal care. Download our Statement of Purpose."
    />
    <link rel="canonical" href="https://www.harpwood.house/cqc-registration" />
  </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section cqc-registration-page">
          <div className="cqc-registration-container">
            <h1>CQC Registration</h1>
            
            <div className="cqc-content">
              <p>Our personal care and nursing care services are registered with the Care Quality Commission (CQC), which regulates and inspects all adult social care services in the public, private and voluntary sectors in England.</p>
            </div>
          </div>
        </section>

        <section className="content-section statement-of-purpose">
          <div className="cqc-registration-container">
            <h1>Statement of Purpose</h1>
            <div className="cqc-content">
              <p>We are required by Regulation to provide a Statement of Purpose.</p>
              <p>This will tell you all about the home, our aims and objectives together with philosophy of care. It includes a description of the services and facilities on offer at the home.</p>
              <p><a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood Statement of Purpose.pdf')} className="nurse-care-link" target="_blank" rel="noopener noreferrer">Download Statement of Purpose (PDF)</a></p>
            </div>
          </div>
        </section>

        <section className="content-section cqc-widget-section" aria-label="CQC widget">
          <div id="cqc-widget-container" className="cqc-widget-wrapper" ref={widgetWrapperRef} />
        </section>
      </main>

      <Footer />
    </div>
    </>
  );
}

export default CQCRegistration;

